module.exports = __webpack_public_path__ + "img/contacto_16-9_1920.ae52da18.jpg";